var version = '1.44.0';
export default version;
